import { render, staticRenderFns } from "./TaskLogFilters.vue?vue&type=template&id=6dffba4e&scoped=true&"
import script from "./TaskLogFilters.vue?vue&type=script&lang=js&"
export * from "./TaskLogFilters.vue?vue&type=script&lang=js&"
import style0 from "./TaskLogFilters.vue?vue&type=style&index=0&id=6dffba4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dffba4e",
  null
  
)

export default component.exports